// Routes du conseil (lot L5-B, M16), raccordées dans Application.tsx par une seule ligne.
import type { RouteObject } from 'react-router';
import { PageElus } from './PageElus';
import { PageSession } from './PageSession';
import { PageSessions } from './PageSessions';

export const routesConseils: RouteObject[] = [
  { path: '/conseil', element: <PageSessions /> },
  { path: '/conseil/elus', element: <PageElus /> },
  { path: '/conseil/sessions/:id', element: <PageSession /> },
];
